export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./view-buttons.vue?vue&type=template&id=50854efc&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/view-buttons/view-buttons.vue?vue&type=template&id=50854efc&
// module id = 1152
// module chunks = 0